import {Plot} from './Plot';
export default Plot;